import isString from 'lodash/isString';
import { exception } from '@/exceptions/Exceptions';
import { removeWhiteSpaces } from '@/helpers/StringHelpers';

/**
 * Format coupon code by removing spaces and upper casing the string.
 *
 * @param {String} couponCode
 *
 * @returns {String}
 *
 * @throws {Error}
 */
export const formatCouponCode = (couponCode) => {
    if (!isString(couponCode)) exception('coupon code is not a valid string.');

    return removeWhiteSpaces(couponCode.toUpperCase());
};
